import './index.css';
import React from 'react';
//import ReactDOM from 'react-dom/client';
import * as ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom";
import SglApp from './SglApp';
import axios from "axios";
import reportWebVitals from './reportWebVitals';


let license_key=''
try{
    license_key = JSON.parse(document.getElementById('sgl-root').querySelector("pre").innerHTML)
}catch(e){
    license_key = false
}

if (license_key) {
    if ( !license_key.base_path ) {
        license_key.base_path = ''
    }
     
    // Apply dynamic CSS variables from WordPress configuration
    applyDynamicStyles(license_key);
}

function applyDynamicStyles(config) {
    const root = document.documentElement;
    
    // Apply color configurations if they exist
    if (config.primary_header_color_bg) {
        root.style.setProperty('--sgl-color-primary', config.primary_header_color_bg);
    }
    
    // if (config.primary_header_color_txt) {
    //     root.style.setProperty('--sgl-text-primary', config.primary_header_color_txt);
    // }
    
    // if (config.secondary_header_color_bg) {
    //     root.style.setProperty('--sgl-color-secondary', config.secondary_header_color_bg);
    // }
    
    // if (config.secondary_header_color_txt) {
    //     root.style.setProperty('--sgl-text-secondary', config.secondary_header_color_txt);
    // }
    
    if (config.link_color) {
        root.style.setProperty('--sgl-link-color-primary', config.link_color);
    }
    
    // if (config.link_hover_color) {
    //     root.style.setProperty('--sgl-link-hover-color', config.link_hover_color);
    // }
}

window.initSGL = function (delay=0) {

  setTimeout(function(){
  ReactDOM.render(
      <BrowserRouter basename={license_key.base_path}>
      <div>
    <SglApp 
        license={license_key} 
        base_path={license_key.base_path} 
        hide_mobile_nav={license_key.hide_mobile_nav} 
        nest_api_url={license_key.react_app_nest_api} 
        sgl_api_url={license_key.react_app_sgl_api} 
        sgl_desktop_sidebar={license_key.sgl_desktop_sidebar} 
        sgl_mobile_menu={license_key.sgl_mobile_menu}
        company_url_path={license_key.company_url_path}
    />
      </div>
      </BrowserRouter>
    ,document.getElementById('sgl-root')
  );

  }, delay);

}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
